// extracted by mini-css-extract-plugin
export default {"scope":"fv3iJ","scope--type-warning":"FlxQt","scope--type-error":"_4XgRR"};